var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 34,
    viewBox: "0 0 40 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 28V26.7C4 26.02 4.32 25.38 4.82 25.08C8.2 23.06 12.06 22 16 22C16.06 22 16.1 22 16.16 22.02C16.36 20.62 16.76 19.28 17.34 18.06C16.9 18.02 16.46 18 16 18C11.16 18 6.64 19.34 2.78 21.64C1.02 22.68 0 24.64 0 26.7V32H18.52C17.68 30.8 17.02 29.44 16.58 28H4ZM16 16C20.42 16 24 12.42 24 8C24 3.58 20.42 0 16 0C11.58 0 8 3.58 8 8C8 12.42 11.58 16 16 16ZM16 4C18.2 4 20 5.8 20 8C20 10.2 18.2 12 16 12C13.8 12 12 10.2 12 8C12 5.8 13.8 4 16 4ZM37.5 24C37.5 23.56 37.44 23.16 37.38 22.74L39.66 20.72L37.66 17.26L34.76 18.24C34.12 17.7 33.4 17.28 32.6 16.98L32 14H28L27.4 16.98C26.6 17.28 25.88 17.7 25.24 18.24L22.34 17.26L20.34 20.72L22.62 22.74C22.56 23.16 22.5 23.56 22.5 24C22.5 24.44 22.56 24.84 22.62 25.26L20.34 27.28L22.34 30.74L25.24 29.76C25.88 30.3 26.6 30.72 27.4 31.02L28 34H32L32.6 31.02C33.4 30.72 34.12 30.3 34.76 29.76L37.66 30.74L39.66 27.28L37.38 25.26C37.44 24.84 37.5 24.44 37.5 24ZM30 28C27.8 28 26 26.2 26 24C26 21.8 27.8 20 30 20C32.2 20 34 21.8 34 24C34 26.2 32.2 28 30 28Z",
    fill: "#5C5470"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg4);
export default __webpack_public_path__ + "static/media/img4.b74b0ea3cb186ef791e4cdfa553c9f01.svg";
export { ForwardRef as ReactComponent };